import { Component, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-sub-header',
  templateUrl: './sub-header.component.html',
  styleUrls: ['./sub-header.component.scss']
})
export class SubHeaderComponent implements AfterViewInit {

  constructor() { }

  ngAfterViewInit(): void {
    const navLinks = document.querySelectorAll('.nav-link');
    const navbarCollapse = document.querySelector('.navbar-collapse');

    navLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();

        const targetId = (link as HTMLAnchorElement).getAttribute('href')?.substring(1);
        if (!targetId) {
          return;
        }

        const targetElement = document.getElementById(targetId);
        if (!targetElement) {
          return;
        }

        let offsetPosition;
        if (window.innerWidth <= 991) {
          // Mobile offset
          offsetPosition = targetElement.offsetTop - 360; 
        } else {
          // Desktop offset
          offsetPosition = targetElement.offsetTop - 120; 
        }

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });

        if (navbarCollapse && navbarCollapse.classList.contains('show')) {
          navbarCollapse.classList.remove('show');
        }
      });
    });
  }
}
